/** @file VIEWPORT_LAYERS: Babylon layer masks splitting the puppet (low-res target) from the overlay. */

/**
 * `puppet`: Babylon's default mesh mask, so the runtime's puppet and onion meshes are seen by the puppet camera and
 * rendered into the pixel-art target; `overlay`: the full-resolution camera's own bit (grid, axes, the puppet quad,
 * joints, bones, gizmo). The two never overlap.
 */
export const VIEWPORT_LAYERS = { puppet: 0x0fffffff, overlay: 0x10000000 } as const;
